var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRuFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 21C5.47715 21 0.999999 16.5228 1 11C1 5.47715 5.47715 0.999999 11 1C16.5228 1 21 5.47715 21 11C21 16.5228 16.5228 21 11 21Z",
    fill: "#0052B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3701 7.5C18.9514 3.70333 15.2913 1 10.9997 1C6.7082 0.999999 3.04807 3.70333 1.62933 7.5L20.3701 7.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.62988 14.5C3.04862 18.2967 6.70875 21 11.0003 21C15.2918 21 18.9519 18.2967 20.3707 14.5L1.62988 14.5Z",
    fill: "#D90026"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuFlag);
export default __webpack_public_path__ + "static/media/ru-flag.4fab813f6a8c55dc555af1df0ff1977b.svg";
export { ForwardRef as ReactComponent };